import React from 'react';
import { Typography } from '@mui/material';
import colors from 'src/styles/equalution/colors';
import Testimonial1 from 'src/assets/images/testimonials/testimonial1.png';
import Testimonial2 from 'src/assets/images/testimonials/testimonial2.png';
import Testimonial3 from 'src/assets/images/testimonials/testimonial3.png';
import Testimonial4 from 'src/assets/images/testimonials/testimonial4.png';
import Testimonial5 from 'src/assets/images/testimonials/testimonial5.png';
import SwiperTestimonial from './SwiperTestimonial';

const ClientTestimonials = () => {
  return (
    <>
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 400,
          color: colors.OFF_BLACK,
          marginTop: '20px',
        }}>
        What our clients say
      </Typography>

      <SwiperTestimonial
        data={[
          {
            comment:
              'Equ not only changed my body they also helped me shift my entire mindset, they did for me what I tried to do for myself for so many years in months and no amount of words could explain how grateful I am. This is a game changer.',
            by: '-Ebony',
            image: Testimonial1,
          },
          {
            comment:
              "“I wasn't able to stick with a food program (not calling it diet) for so long and I have been with Equ for 45 weeks now. I'm able to enjoy food. I don't see my nutrition as a diet, but as a lifestyle. I can socialise with my family and friends without feeling guilty.”",
            by: '-Ana',
            image: Testimonial2,
          },
          {
            comment:
              '“It’s been a total game changer for me, as someone who is usually a yo yo dieter to have found something I find totally sustainable is amazing. I haven’t gone without anything, or ever felt restricted in my whole time with Equ.”',
            by: '-Sarah',
            image: Testimonial3,
          },
          {
            comment:
              '“Never in my wildest dreams did I expect to achieve the results I have, but most importantly build a healthier and more balanced lifestyle to implement into my every day routine.”',
            by: '-Peta',
            image: Testimonial4,
          },
          {
            comment:
              '“I have realised there are no ‘good or bad’ foods; it’s all about finding a balance and knowing that you can still dine out and your hard work hasn’t been ‘undone’. I have tried many FAD diets, but nothing compares to this. I wouldn’t even call this a diet.”',
            by: '-Emily',
            image: Testimonial5,
          },
        ]}
      />
    </>
  );
};

export default ClientTestimonials;
